// commercial-mats products (4 items)
export const productsCommercialMats = [
  {
    id: 14,
    slug: "supertac-matting",
    name: "SuperTac Matting",
    variant: "Commercial Matting",
    type: "Commercial Matting",
    category: "Commercial Mats",

    categoryId: "commercial-mats",    productSheetPdf: "/Assets/pdf/supertac-matting/PS_ISS_SuperTac.pdf",
    techSpecsPdf: "/Assets/pdf/supertac-matting/PS_TechSpecs_SuperTac.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 1,
    sizeFormat: "Rolls",
    zones: [3],
      industries: [],
      colorTones: ["charcoal"],
      patterns: ["modern"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/SuperTac/supertac_thumbnail.jpg",
    heroImage: "/Assets/images/products/SuperTac/SuperTac_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "100% PET",
      construction: "Post-Consumer Recycled Polyester Fabric",
      backing: "Proprietary Hydrophobic Adhesive Material",
      thickness: "0.10 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Self-Adhering Mat (Sticks to floor)",
      recommendedZone: "Zone 3",
      bestUseCase: "matting helps to prevent slips/falls in wet or oily areas, areas that need a temporary mat solution"
    },
    keyFeatures: [
      "Self-adhering, hassle-free solution",
      "Moisture barrier prevents liquids from soaking through",
      "Made from 100% recyclable and disposable materials"
    ],
    gallery: [
      "/Assets/images/products/SuperTac/SuperTac_hero.jpg",
      "/Assets/images/new-product-imgs/SuperTac-Matting/SuperTacMat_Near_Fountain.jpg",
      "/Assets/images/products/SuperTac/supertac_grocery_coffee.jpg",
      "/Assets/images/products/SuperTac/supertac_img_6470.jpg",
      "/Assets/images/products/SuperTac/supertac_roll_30.jpg",
      "/Assets/images/products/SuperTac/supertac_install_layout.jpg",
      "/Assets/images/products/SuperTac/supertac_install_cutting.jpg",
      "/Assets/images/products/SuperTac/supertac_cb_closeup.jpg",
      "/Assets/images/products/SuperTac/supertac_undercut_diagram.jpg"
    ],
    swatchesLabel: "Accessories",
    swatches: [
      { name: "Roll", image: "/Assets/images/products/SuperTac/SuperTac_Roll_30.jpg" },
      { name: "Accessories", image: "/Assets/images/products/SuperTac/SuperTac_Accessories_27.jpg" }
    ],
    isPlaceholder: false,
    description: "SuperTac Matting is a hassle-free, self-adhering solution designed for safety and convenience in high-risk areas. Made from 100% recyclable and disposable materials, this mat offers reliable floor protection while helping prevent slips and falls in wet or oily environments. Whether you're dealing with heavy cart traffic or daily cleaning routines, SuperTac stays securely in place and keeps your floors dry.",
    features: [
      "Moisture barrier prevents liquids from soaking through",
      "Adhesive backing keeps the mat flat",
      "Cut individual mats from the roll as needed"
    ],
    specifications: {
      type: "FAST INSTALLING INDOOR MATTING",
      material: "100% Post-Consumer Recycled Polyester Fabric",
      treatment: "Odor Resistant - Anti-microbially treated for protection"
    }
  },
  {
      id: 42,
      slug: "channel-rib-cm",
      name: "Channel Rib",
      variant: "Commercial Matting",
      type: "Commercial Matting",
      category: "Commercial Mats",

    categoryId: "commercial-mats",
      productSheetPdf: "/Assets/pdf/channel-rib-cm/PS_ISS_ChannelRib.pdf",
    techSpecsPdf: "/Assets/pdf/channel-rib-cm/PS_TechSpecs_ChannelRib.pdf",
      saleSheetPdf: "/Assets/pdf/channel-rib-cm/PS_ISS_ChannelRib.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 6,
      sizeFormat: "Rolls / Sheets",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["red", "blue", "charcoal", "green", "brown"],
      patterns: ["ribbed", "textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/channel-rib-cm/channel-rib-cm_thumbnail.jpg",
      heroImage: "/Assets/images/products/channel-rib-cm/channel-rib-cm_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"}
      ],
    comparisonSpecs: {
      material: "2x2 ribbed pattern",
      construction: "Solution Dyed Polypropylene",
      backing: "Vinyl",
      thickness: "0.3125 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
      keyFeatures: ["Ribbed pattern channels water away while making it easy to sweep off dirt and debris", "High quality vinyl backing"],
      gallery: ["/Assets/images/products/channel-rib-cm/channel-rib-cm_hero.jpg", "/Assets/images/products/channel-rib-cm/channel-rib-cm_gallery_1.jpg", "/Assets/images/products/channel-rib-cm/channel-rib-cm_gallery_2.jpg", "/Assets/images/products/channel-rib-cm/channel-rib-cm_gallery_3.jpg", "/Assets/images/products/channel-rib-cm/channel-rib-cm_gallery_4.jpg", "/Assets/images/products/channel-rib-cm/channel-rib-cm_gallery_5.jpg"],
      swatches: [
        {name: "Red", image: "/Assets/images/products/channel-rib-cm/swatches/Red.jpg"},
        {name: "Evergreen", image: "/Assets/images/products/channel-rib-cm/swatches/Evergreen.jpg"},
        {name: "Brown", image: "/Assets/images/products/channel-rib-cm/swatches/Brown.jpg"},
        {name: "Dark Grey", image: "/Assets/images/products/channel-rib-cm/swatches/Dark-Grey.jpg"},
        {name: "Charcoal", image: "/Assets/images/products/channel-rib-cm/swatches/Charcoal.jpg"},
        {name: "Slate Blue", image: "/Assets/images/products/channel-rib-cm/swatches/Slate-Blue.jpg"}
      ],
      isPlaceholder: false,
      description: "Facilities need entrance matting that controls dirt and moisture without stretching the budget. Channel Rib delivers dependable performance with a classic ribbed design that helps channel water away while making dirt and debris easy to sweep or vacuum. Made with 100% solution-dyed, UV-stabilized polypropylene and a durable vinyl backing, it performs reliably in both indoor and outdoor applications. Ideal for entryways and ramps, Channel Rib provides a practical, cost-effective matting solution for busy commercial spaces.",
      features: ["Ribbed pattern channels water away while making it easy to sweep off dirt and debris", "High quality vinyl backing"],
      specifications: {}
    },
  {
      id: 43,
      slug: "chevron-rib-cm",
      name: "Chevron Rib",
      variant: "Commercial Matting",
      type: "Commercial Matting",
      category: "Commercial Mats",

    categoryId: "commercial-mats",
      productSheetPdf: "/Assets/pdf/chevron-rib-cm/PS_ISS_ChevronRib.pdf",
    techSpecsPdf: "/Assets/pdf/chevron-rib-cm/PS_TSS_ChevronRib.pdf",
      saleSheetPdf: "/Assets/pdf/chevron-rib-cm/PS_ISS_ChevronRib.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 4,
      sizeFormat: "Rolls / Sheets",
      zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["red", "blue", "charcoal", "brown"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/chevron-rib-cm/chevron-rib-cm_thumbnail.jpg",
      heroImage: "/Assets/images/products/chevron-rib-cm/chevron-rib-cm_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"}
      ],
    comparisonSpecs: {
      material: "Solution-dyed polypropylene",
      construction: "Herringbone Pattern",
      backing: "Vinyl",
      thickness: "0.375 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zones 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
      keyFeatures: ["Dirt, debris and moisture gets trapped in the pattern/grooves of the mat and stays off", "Stain and fade resistant needle-punch carpet", "Used for low to moderate traffic, indoor only environments."],
      gallery: ["/Assets/images/products/chevron-rib-cm/chevron-rib-cm_gallery_1.jpg"],
      swatches: [
        {name: "Brown", image: "/Assets/images/products/chevron-rib-cm/swatches/Brown.jpg"},
        {name: "Charcoal", image: "/Assets/images/products/chevron-rib-cm/swatches/Charcoal.jpg"},
        {name: "Blue", image: "/Assets/images/products/chevron-rib-cm/swatches/Blue.jpg"},
        {name: "Burgundy", image: "/Assets/images/products/chevron-rib-cm/swatches/Burgundy.jpg"}
      ],
      isPlaceholder: false,
      description: "When you need entrance matting that actively removes dirt and moisture from incoming foot traffic, Chevron Rib offers a dependable indoor solution. Its classic herringbone pattern features multi-directional raised ribs that brush debris from shoes regardless of traffic flow. Durable needle-punch polypropylene fibers help retain moisture, while the bi-level construction traps and hides dirt below the surface. Finished with a non-slip vinyl backing to minimize movement on hard floors, Chevron Rib provides a practical, easy-to- maintain mat designed for low to moderate traffic indoor environments.",
      features: ["Dirt, debris and moisture gets trapped in the pattern/grooves of the mat and stays off", "Stain and fade resistant needle-punch carpet", "Used for low to moderate traffic, indoor only environments."],
      specifications: {}
    },
  {
      id: 67,
      slug: "tidal-tidal-diamond-cm",
      name: "Tidal & Tidal Diamond",
      variant: "Commercial Matting",
      type: "Commercial Matting",
      category: "Commercial Mats",

    categoryId: "commercial-mats",
      productSheetPdf: "/Assets/pdf/tidal-tidal-diamond-cm/PS_ISS_TidalMat.pdf",
    techSpecsPdf: "/Assets/pdf/tidal-tidal-diamond-cm/PS_TechSpecs_Tidal.pdf",
      saleSheetPdf: "/Assets/pdf/tidal-tidal-diamond-cm/PS_ISS_TidalMat.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 7,
      sizeFormat: "Rolls / Sheets",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "black", "blue", "green", "brown", "red"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/tidal-tidal-diamond-cm/tidal-tidal-diamond-cm_thumbnail.jpg",
      heroImage: "/Assets/images/products/tidal-tidal-diamond-cm/tidal-tidal-diamond-cm_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"}
      ],
      comparisonSpecs: {
        material: "Solution-dyed polypropylene",
        construction: "Waffle or Diamond Cleated Pattern",
        backing: "Double Nitrile Rubber",
        thickness: "0.3125 inch",
        trafficRating: "Medium",
        slipResistance: "Yes",
        installationType: "Loose Lay Mat",
        recommendedZone: "Zones 1, 2, 3",
        bestUseCase: "Inlay matting, entryways"
      },
    keyFeatures: ["Beveled edging traps dirt and water", "Prevents slip hazards", "Helps maintain indoor floor covering"],
      gallery: ["/Assets/images/products/tidal-tidal-diamond-cm/tidal-tidal-diamond-cm_hero.jpg", "/Assets/images/products/tidal-tidal-diamond-cm/tidal-tidal-diamond-cm_gallery_1.jpg", "/Assets/images/products/tidal-tidal-diamond-cm/tidal-tidal-diamond-cm_gallery_2.jpg", "/Assets/images/products/tidal-tidal-diamond-cm/tidal-tidal-diamond-cm_gallery_4.jpg"],
      swatches: [
        {name: "Navy", image: "/Assets/images/products/tidal-tidal-diamond-cm/swatches/Navy.jpg"},
        {name: "Red", image: "/Assets/images/products/tidal-tidal-diamond-cm/swatches/Red.jpg"},
        {name: "Evergreen", image: "/Assets/images/products/tidal-tidal-diamond-cm/swatches/Evergreen.jpg"},
        {name: "Brown", image: "/Assets/images/products/tidal-tidal-diamond-cm/swatches/Brown.jpg"},
        {name: "Grey", image: "/Assets/images/products/tidal-tidal-diamond-cm/swatches/Grey.jpg"},
        {name: "Charcoal", image: "/Assets/images/products/tidal-tidal-diamond-cm/swatches/Charcoal.jpg"},
        {name: "Burgundy", image: "/Assets/images/products/tidal-tidal-diamond-cm/swatches/Burgundy.jpg"}
      ],
      isPlaceholder: false,
      description: "In areas where wet weather and heavy foot traffic are common, flooring needs to actively control moisture and debris. Tidal Mat is engineered to scrape dirt and snow while capturing water before it spreads across surrounding floors. Its beveled edging and deep water-trapping design help reduce slip hazards while protecting interior floor covering. Built with Grip-Nobs on the backing to keep the mat securely in place on both carpet and hard surfaces, Tidal Mat provides dependable floor protection and can also be customized with a logo to reinforce your brand.",
      features: ["Beveled edging traps dirt and water", "Prevents slip hazards", "Helps maintain indoor floor covering"],
      specifications: {}
    },
];
